(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["MilbLinker"] = factory();
	else
		root["MilbLinker"] = factory();
})(this, function() {

'use strict';

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/******/return (function (modules) {
    // webpackBootstrap
    /******/ // The module cache
    /******/var installedModules = {};
    /******/
    /******/ // The require function
    /******/function __webpack_require__(moduleId) {
        /******/
        /******/ // Check if module is in cache
        /******/if (installedModules[moduleId]) {
            /******/return installedModules[moduleId].exports;
            /******/
        }
        /******/ // Create a new module (and put it into the cache)
        /******/var module = installedModules[moduleId] = {
            /******/i: moduleId,
            /******/l: false,
            /******/exports: {}
            /******/ };
        /******/
        /******/ // Execute the module function
        /******/modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
        /******/
        /******/ // Flag the module as loaded
        /******/module.l = true;
        /******/
        /******/ // Return the exports of the module
        /******/return module.exports;
        /******/
    }
    /******/
    /******/
    /******/ // expose the modules object (__webpack_modules__)
    /******/__webpack_require__.m = modules;
    /******/
    /******/ // expose the module cache
    /******/__webpack_require__.c = installedModules;
    /******/
    /******/ // identity function for calling harmony imports with the correct context
    /******/__webpack_require__.i = function (value) {
        return value;
    };
    /******/
    /******/ // define getter function for harmony exports
    /******/__webpack_require__.d = function (exports, name, getter) {
        /******/if (!__webpack_require__.o(exports, name)) {
            /******/Object.defineProperty(exports, name, {
                /******/configurable: false,
                /******/enumerable: true,
                /******/get: getter
                /******/ });
            /******/
        }
        /******/
    };
    /******/
    /******/ // getDefaultExport function for compatibility with non-harmony modules
    /******/__webpack_require__.n = function (module) {
        /******/var getter = module && module.__esModule ?
        /******/function getDefault() {
            return module['default'];
        } :
        /******/function getModuleExports() {
            return module;
        };
        /******/__webpack_require__.d(getter, 'a', getter);
        /******/return getter;
        /******/
    };
    /******/
    /******/ // Object.prototype.hasOwnProperty.call
    /******/__webpack_require__.o = function (object, property) {
        return Object.prototype.hasOwnProperty.call(object, property);
    };
    /******/
    /******/ // __webpack_public_path__
    /******/__webpack_require__.p = "";
    /******/
    /******/ // Load entry module and return exports
    /******/return __webpack_require__(__webpack_require__.s = 0);
    /******/
})(
/************************************************************************/
/******/[
/* 0 */
/***/function (module, exports, __webpack_require__) {

    "use strict";

    /**
     * Static methods which validate values passed to functions (or for other validation uses).  Each throws an Error if
     * the passed value(s) is not valid; exits silently if valid.
     * @private
     */

    var BamArgValidator$1 = function () {
        function BamArgValidator$1() {
            _classCallCheck(this, BamArgValidator$1);
        }

        _createClass(BamArgValidator$1, null, [{
            key: 'validateArgs',


            /**
             * Validates the args passed to a function, throws an error if invalid values found
             * @param {object} passedArgs the "arguments" property of the calling function
             * @param {array} argNamesArr Array of function-param names (used in error-messaging)
             * @param {array} expectedTypesArr array of types (first el for first arg, second el for second arg, etc.).  More than one
             *   type is supported; separate supported types with a pipe.  For the purposes of this validation, the following
             *   are valid types: the standard types ("undefined", "object", "boolean", "number", "string", "symbol", and
             *   "function"), plus "null" and "array".  So for example, if a string or null is accepted for a given arg, the
             *   type would be "string|null"
             * @param {array} requiredBooleansArr An array of booleans; array must be same length as `expectedTypesArr`. Els should be
             *   true for required values, false otherwise; e.g., this array requires the first two of a possible four args:
             *   [true, true, false, false].  For the purposes of this method, an arg has been passed if it is not undefined.
             * @throws Error if invalid or missing args found
             */
            value: function validateArgs(passedArgs, argNamesArr, expectedTypesArr, requiredBooleansArr) {
                if (argNamesArr.length !== expectedTypesArr.length) {
                    throw new Error('expectedTypesArr, and argNamesArr must be the same length');
                }

                if (passedArgs.length > argNamesArr.length) {
                    throw new Error('this function takes ' + argNamesArr.length + ' args, but you passed ' + passedArgs.length + '.');
                }

                var required = void 0;
                var argVal = void 0;
                var allowedTypes = void 0;
                var validTypeFound = void 0;
                var argName = void 0;
                for (var i = 0; i < expectedTypesArr.length; ++i) {
                    argName = argNamesArr[i];
                    argVal = i >= passedArgs.length ? undefined : passedArgs[i];
                    required = requiredBooleansArr[i];
                    if (required && argVal === undefined) {
                        throw new Error('The "' + argName + '" param is required.');
                    }
                    allowedTypes = expectedTypesArr[i].split('|');
                    validTypeFound = false;
                    for (var _i = 0; _i < allowedTypes.length; ++_i) {
                        var allowedType = allowedTypes[_i];
                        if (argVal === undefined && !required || allowedType === 'array' && Array.isArray(argVal) || allowedType === 'null' && argVal === null || (typeof argVal === 'undefined' ? 'undefined' : _typeof(argVal)) === allowedType) {
                            validTypeFound = true;
                            break;
                        }
                    }
                    if (!validTypeFound) {
                        throw new Error('The "' + argName + '" param is an unsupported type; supported type(s): ' + expectedTypesArr[i].replace(/\|/g, ', '));
                    }
                }
            }

            /**
             * Throws an error if person is not a valid statsapi person node
             * @param person
             * @throws Error if invalid person node
             */

        }, {
            key: 'validateStatsapiPerson',
            value: function validateStatsapiPerson(person) {
                if ((typeof person === 'undefined' ? 'undefined' : _typeof(person)) !== 'object' || person.id === undefined || person.fullName === undefined) {
                    throw new Error('person must be a valid statsapi person node, as returned by various Sports Data APIs.');
                }
            }

            /**
             * Throws an error if team is not a valid statsapi team node
             * @param team
             * @throws Error if invalid team node
             */

        }, {
            key: 'validateStatsapiTeam',
            value: function validateStatsapiTeam(team) {
                if ((typeof team === 'undefined' ? 'undefined' : _typeof(team)) !== 'object' || !BamArgValidator$1._hasAllProps(team, ['id', 'name', 'teamName', 'shortName'])) {
                    throw new Error('team must be a valid statsapi team node, as returned by the Teams API.');
                }
            }

            /**
             * Throws an error if game is not a valid statsapi game node
             * @param game
             * @throws Error if invalid game node
             */

        }, {
            key: 'validateStatsapiGame',
            value: function validateStatsapiGame(game) {
                if ((typeof game === 'undefined' ? 'undefined' : _typeof(game)) !== 'object' || !BamArgValidator$1._hasAllProps(game, ['gamePk', 'gameType', 'gameDate', 'status', 'teams'])) {
                    throw new Error('game must be a valid statsapi game node, as returned by the Schedule API.');
                }
            }

            /**
             * Throws an error if game is not a valid statsapi event node
             * @param nonGameEvent
             * @throws Error if invalid event node
             */

        }, {
            key: 'validateStatsapiNonGameEvent',
            value: function validateStatsapiNonGameEvent(nonGameEvent) {
                if ((typeof nonGameEvent === 'undefined' ? 'undefined' : _typeof(nonGameEvent)) !== 'object' || !BamArgValidator$1._hasAllProps(nonGameEvent, ['id', 'eventType', 'eventDate', 'venue', 'teams'])) {
                    throw new Error('non game event must be a valid statsapi event node, as returned by the Schedule API.');
                }
            }

            /**
             * Throws an error if s is not a value of type number, or a string which can be converted to a number
             * @param s
             * @throws Error if s isn't a number
             */

        }, {
            key: 'validateNumber',
            value: function validateNumber(s) {
                if (typeof s === 'number') {
                    return;
                }
                if (typeof s === 'string' && !isNaN('' + s)) {
                    return;
                }
                throw new Error('not convertible to a numeric value: ' + s);
            }

            /**
             * Passed a value (typically of a function param), throws an error if that value is not in an array of accepted
             * values.
             * @param {*} val The value we're evaluating for validity
             * @param {array} allowedVals Allowed values
             * @throws Error if the value is not valid
             */

        }, {
            key: 'validateAllowed',
            value: function validateAllowed(val, allowedVals) {
                var allowed = Array.isArray(allowedVals) ? allowedVals : [allowedVals];
                if (allowed.indexOf(val) === -1) {
                    throw new Error('' + val + ' is not valid; accepted values are: ' + allowed);
                }
            }

            /**
             * Returns false if obj does not have all the properties in the required-props array, true if valid
             * @param obj An object
             * @param requiredPropsArr And array of strings; each el is the name of a property which the object must have
             * @private
             */

        }, {
            key: '_hasAllProps',
            value: function _hasAllProps(obj, requiredPropsArr) {
                for (var i = 0; i < requiredPropsArr.length; ++i) {
                    var prop = requiredPropsArr[i];
                    if (obj[prop] === undefined) {
                        return false;
                    }
                }
                return true;
            }
        }]);

        return BamArgValidator$1;
    }();

    /**
     *
     * @author [(Shojib, mahmud.hossain@mlb.com)]
     * @module BaseLinker
     *
     */

    /**
     * @class BaseLinker
     */


    var BaseLinker = function () {

        /**
         * @method constructor
         * @param options (siteId, teamId, leagueId, ymdDate, calEventId, gameId, videoId)
         */
        function BaseLinker(windowOrReq) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, BaseLinker);

            var metaTeamId = void 0;
            var metaLeagueId = void 0;
            var metaAppView = void 0;
            var metaLocale = void 0;
            var metaSlug = void 0;

            if (windowOrReq.navigator) {
                this._deviceType = windowOrReq.getStartupDeviceTypeString ? windowOrReq.getStartupDeviceTypeString() : 'desktop';
                this._metaTags = windowOrReq.document.getElementsByTagName('meta');

                metaTeamId = this.getMetaTagContent(this._metaTags, 'team-id');
                metaLeagueId = this.getMetaTagContent(this._metaTags, 'league-id');
                metaAppView = this.getMetaTagContent(this._metaTags, 'app-view');
                metaLocale = this.getMetaTagContent(this._metaTags, 'locale');
                metaSlug = this.getMetaTagContent(this._metaTags, 'club');
            } else if (windowOrReq.locals) {
                var _ref = windowOrReq.locals.globalData || {},
                    team = _ref.team,
                    league = _ref.league;

                var _ref2 = windowOrReq.locals.responseConfig || {},
                    appViews = _ref2.appViews,
                    locale = _ref2.locale,
                    club = _ref2.club;

                this._deviceType = options.deviceType || 'desktop';
                metaTeamId = team && team.data && team.data.team.id;
                metaLeagueId = league && league.data && league.data.league.id;
                metaAppView = appViews || '';
                metaLocale = locale || 'en';
                metaSlug = !club ? '' : club;
            }

            var siteId = void 0;

            if (metaTeamId) {
                siteId = 't' + metaTeamId;
            } else if (metaLeagueId) {
                siteId = 'l' + metaLeagueId;
            } else {
                siteId = null;
            }

            if (options.langCodeOverride) {
                options.locale = options.langCodeOverride;
            }

            if (options.teamSlugs || windowOrReq.teamSlugs) {
                options.teamSlugs = options.teamSlugs || windowOrReq.teamSlugs || null;
            }

            this._siteId = options.siteId || siteId;
            this._teamId = options.teamId || metaTeamId;
            this._slug = options.slug || metaSlug || '';
            this._leagueId = options.leagueId || metaLeagueId;
            this._appView = options.appView || metaAppView;
            this._langCode = options.locale || metaLocale;

            this._ymdDate = options.ymdDate || null;
            this._calEventId = options.calEventId || null;
            this._gameId = options.gameId || null;
            this._videoId = options.videoId || null;
            this._teamSlugs = options.teamSlugs || null;
            this._sportCodeMap = {
                11: 'aaa',
                12: 'aax',
                13: 'afa',
                14: 'afx',
                15: 'asx',
                16: 'rok',
                17: 'win'
            };
        }

        _createClass(BaseLinker, [{
            key: 'getMetaTagContent',


            /**
             * @method getMetaTagContent
             * @param metaTagEls, key
             */
            value: function getMetaTagContent(metaTagEls, key) {
                var metaTagKeyAttrNames = ['name', 'property', 'http-equiv'];

                for (var k = 0, kln = metaTagKeyAttrNames.length; k < kln; k++) {
                    for (var i = 0, mln = metaTagEls.length; i < mln; i++) {
                        if (metaTagEls[i].getAttribute(metaTagKeyAttrNames[k]) === key) {
                            return metaTagEls[i].getAttribute('content');
                        }
                    }
                }
                return null;
            }

            /**
             * @method buildLink
             * @param linker, urlSegment, keepTeam
             */

        }, {
            key: 'buildLink',
            value: function buildLink(linker, urlSegment, keepTeam) {
                BamArgValidator$1.validateArgs(arguments, ['linker', 'urlSegment', 'keepTeam'], ['object', 'string', 'boolean'], [true, true, false]);

                var url = (linker._appView === 'web' ? '' : '/' + linker._appView) + (linker._langCode === 'en' ? '' : '/' + linker._langCode) + (keepTeam ? linker._slug ? '/' + linker._slug : '' : '') + urlSegment;
                return url;
            }

            /**
             * @method getLink
             * @param urlSegment, keepTeam
             */

        }, {
            key: 'getLink',
            value: function getLink(urlSegment, keepTeam) {
                BamArgValidator$1.validateArgs(arguments, ['urlSegment', 'keepTeam'], ['string', 'boolean'], [true, false]);
                var keepTeamPathElement = keepTeam === undefined ? true : keepTeam;

                var segment = '' + urlSegment;
                if (segment.charAt(0) !== '/') {
                    segment = '/' + segment;
                }

                return this.buildLink(this, segment, keepTeamPathElement);
            }
        }, {
            key: 'siteId',
            set: function set(sId) {
                this._siteId = sId;
            },
            get: function get() {
                return this._siteId;
            }
        }, {
            key: 'leagueId',
            set: function set(id) {
                this._leagueId = id;
            },
            get: function get() {
                return this._leagueId;
            }
        }, {
            key: 'ymdDate',
            set: function set(ymd) {
                this._ymdDate = ymd;
            },
            get: function get() {
                return this._ymdDate;
            }
        }, {
            key: 'calEventId',
            set: function set(calEvtId) {
                this._calEventId = calEvtId;
            },
            get: function get() {
                return this._calEventId;
            }
        }, {
            key: 'gameId',
            set: function set(gId) {
                this._gameId = gId;
            },
            get: function get() {
                return this._gameId;
            }
        }, {
            key: 'videoId',
            set: function set(vidId) {
                this._videoId = vidId;
            },
            get: function get() {
                return this._videoId;
            }
        }, {
            key: 'metaTags',
            set: function set(mTags) {
                this._metaTags = mTags;
            },
            get: function get() {
                return this._metaTags;
            }
        }, {
            key: 'sportCodeMap',
            get: function get() {
                return this._sportCodeMap;
            }
        }, {
            key: 'teamSlugs',
            get: function get() {
                return this._teamSlugs;
            }
        }]);

        return BaseLinker;
    }();

    /**
     * @author [(Shojib, mahmud.hossain@mlb.com)]
     * @module MilBLinker
     * @description MiLB linker class
     * @name MilB Linker
     */

    var isArray = Array.isArray;

    /**
     * @class MilbLinker
     * @extends Linker
     * @description MiLB Linker that creates the links
     */

    var MilbLinker = function (_BaseLinker) {
        _inherits(MilbLinker, _BaseLinker);

        /**
         * @method constructor
         * @param options
         */
        function MilbLinker(windowObj) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, MilbLinker);

            var _this = _possibleConstructorReturn(this, (MilbLinker.__proto__ || Object.getPrototypeOf(MilbLinker)).call(this, windowObj, options));

            _this.HIDDEN_GAMEDAY_TYPES = {
                N: true,
                L: true,
                S: true
            };

            _this.milbHostName = 'http://www.milb.com';
            _this.milbMobileHostName = 'http://m.milb.com';
            return _this;
        }

        /**
         * @method getStandingsLink
         * @description Return a standings link
         * @return {string} url path
         */


        _createClass(MilbLinker, [{
            key: 'getStandingsLink',
            value: function getStandingsLink(leagueId) {
                var _leagueId = leagueId || this.leagueId;
                return this.milbHostName + '/standings/index.jsp?lid=' + _leagueId;
            }

            /**
             * @method getAudioLink
             * @description Return audio link
             * @return {string} url path
             */

        }, {
            key: 'getAudioLink',
            value: function getAudioLink() {
                var platform = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

                var _teamId = this._teamId;
                if (this._appView !== 'web') {
                    return this.milbMobileHostName + '/gdaudio/' + (platform || 'iphone');
                }
                return this.milbHostName + '/milb/multimedia/audio.jsp?sid=t' + _teamId;
            }

            /**
             * @method getTuneInLinkForContextTeam
             * @description Return tunein link
             * @return {string} url path
             */

        }, {
            key: 'getTuneInLinkForContextTeam',
            value: function getTuneInLinkForContextTeam(statsapiGame) {
                return _getTuneInLink(statsapiGame, this, 'contextOnly');
            }

            /**
             * @method getTuneInLink
             * @description Return tunein link
             * @return {string} url path
             */

        }, {
            key: 'getTuneInLink',
            value: function getTuneInLink(statsapiGame) {
                var homeOrAway = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'any';

                return _getTuneInLink(statsapiGame, this, homeOrAway);
            }

            /**
             * @method getGamedayLink
             * @description Return a gameday link
             * @return {string} url path
             */

        }, {
            key: 'getGamedayLink',
            value: function getGamedayLink(statsapiGame) {
                var ignoreGameState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                BamArgValidator$1.validateStatsapiGame(statsapiGame);
                var _statsapiGame$status = statsapiGame.status,
                    status = _statsapiGame$status === undefined ? {} : _statsapiGame$status,
                    gamedayType = statsapiGame.gamedayType;


                if (!ignoreGameState) {
                    if (status.abstractGameCode === 'F' || status.codedGameState === 'S') {
                        return null;
                    }
                }

                if (this.HIDDEN_GAMEDAY_TYPES[gamedayType]) {
                    return null;
                }

                return this.getLink('/gameday/' + statsapiGame.gamePk, false);
            }

            /**
             * @method getVideoLink
             * @description Return a video link
             * @return {string} url path
             */

        }, {
            key: 'getVideoLink',
            value: function getVideoLink(contentId) {
                return this.milbHostName + '/r/video?content_id=' + contentId;
            }

            /**
             * @method getTvLink
             * @description Return mlb.tv link
             * @return {string} url path
             */

        }, {
            key: 'getTvLink',
            value: function getTvLink(statsapiGame, liveStream) {
                var gamePk = statsapiGame.gamePk;
                var season = statsapiGame.season;
                var tvURL = '';

                // no milb.tv links before 2019
                if (parseInt(season, 10) > 2018) {
                    // check that game is scheduled for streaming unless we're asked only for live streams
                    if (statsapiGame.broadcasts && !liveStream) {
                        var b = void 0;
                        for (b = 0; b < statsapiGame.broadcasts.length; ++b) {
                            if (statsapiGame.broadcasts[b].id === 1765) {
                                // TODO: ADD DATE TO URL WHEN AWS GRID HAS FUTURE GAMES ON GRID AND DATE ROUTE
                                tvURL = '/live-stream-games';
                            }
                        }
                    }

                    // check media states
                    if (statsapiGame.content) {
                        var mediaOnOrArchive = false;
                        var epg = statsapiGame.content.media && statsapiGame.content.media.epg || [];
                        if (!isArray(epg)) {
                            epg = [epg];
                        }
                        var hasMedia = epg.some(function (epgItem) {
                            if (epgItem.title === 'MiLBTV' && epgItem.items.length) {
                                return epgItem.items.some(function (item) {
                                    mediaOnOrArchive = item.mediaState === 'MEDIA_ON' || item.mediaState === 'MEDIA_ARCHIVE';
                                    // TODO UPDATE WITH ADDITIONAL MEDIA STATES WHEN THEY ARE ADDED
                                    return mediaOnOrArchive;
                                });
                            }
                            return false;
                        });
                        if (hasMedia) {
                            tvURL = '/live-stream-games/g' + gamePk;
                        }
                    }
                }

                if (tvURL.length > 0) {
                    return this.getLink(tvURL, false);
                } else {
                    return '';
                }
            }

            /**
             * @method getPlayerPageLink
             * @description Return player link
             * @param {object} statsapiPerson Person response object.
             * @param {mixed} [teamId] Optional team id as string or number for building team context urls.
             * @param {string} [platform] Optional platform string (ios, android) for targeting
             *                            device-specific versions of the mobile player cards.
             * @return {string} url path
             */

        }, {
            key: 'getPlayerPageLink',
            value: function getPlayerPageLink(statsapiPerson) {
                var teamId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
                var platform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

                var _teamId = teamId || this.teamId;

                // @see params above
                BamArgValidator$1.validateArgs(arguments, ['statsapiPerson', '_teamId', 'platform'], ['object', 'string|number', 'string'], [true, false, false]);
                BamArgValidator$1.validateStatsapiPerson(statsapiPerson);

                if (this._appView !== 'web') {
                    return this.milbMobileHostName + '/milb/' + (platform || 'iphone') + '/player/' + statsapiPerson.id;
                }

                if (_teamId) {
                    return '/r/player/' + _teamId + '/' + statsapiPerson.id;
                } else {
                    return '/r/player/' + statsapiPerson.id;
                }
            }

            /**
             * If a game is in pregame, return a gameday preview link, otherwise null
             * If a plain gameday link is available, don't return a preview link
             * @param statsapiGame
             * @return {string}
             */

        }, {
            key: 'getPreviewLink',
            value: function getPreviewLink(statsapiGame) {

                BamArgValidator$1.validateStatsapiGame(statsapiGame);

                if (statsapiGame.status) {

                    var code = statsapiGame.status.abstractGameCode;

                    if (code && code === 'P') {

                        var gameDayLink = this.getGamedayLink(statsapiGame);

                        if (!gameDayLink) {
                            return this.getLink('/gameday/' + statsapiGame.gamePk + '/preview', false);
                        }
                    }
                }

                return null;
            }

            /**
             * @method getBoxscoreLink
             * @description Return a gameday link
             * @return {string} url path
             */

        }, {
            key: 'getBoxscoreLink',
            value: function getBoxscoreLink(statsapiGame) {
                var ignoreGameState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

                BamArgValidator$1.validateStatsapiGame(statsapiGame);

                if (statsapiGame.status) {
                    var code = statsapiGame.status.abstractGameCode;

                    if (code && code === 'F') {
                        var statusCode = statsapiGame.status.statusCode;
                        var firstLetter = statusCode && statusCode.charAt(0) || '';

                        if (firstLetter && firstLetter !== 'D' && firstLetter !== 'C') {
                            return this.getLink('/gameday/' + statsapiGame.gamePk + '/final/box', false);
                        }
                    }
                }

                return null;
            }

            /**
             * @method getTeamHomepageLink
             * @description Return team homepage url
             * @return {string} url path
             */

        }, {
            key: 'getTeamHomepageLink',
            value: function getTeamHomepageLink(statsapiTeam) {
                BamArgValidator$1.validateStatsapiTeam(statsapiTeam);
                var teamId = statsapiTeam.id || this.teamId;
                return this.milbHostName + '/index.jsp?sid=t' + teamId;
            }

            /**
             * @method getWrapLink
             * @description Return wrap link
             * @return {string} url path
             */

        }, {
            key: 'getWrapLink',
            value: function getWrapLink(statsapiGame, sId) {
                BamArgValidator$1.validateStatsapiGame(statsapiGame);
                var _statsapiGame$content = statsapiGame.content,
                    content = _statsapiGame$content === undefined ? {} : _statsapiGame$content;

                var gid = _getGID(statsapiGame, this);

                //TODO: Find out if this should use content.editorial.milb_recap instead of hasWrapArticle
                if (content.summary) {
                    var hasWrapArticle = content.summary.hasWrapArticle;


                    if (hasWrapArticle) {
                        var siteId = sId || this.siteId;
                        return _getStatsLink(this.milbHostName, gid, siteId);
                    }
                }

                return null;
            }

            /**
             * @method getStatsLink
             * @description Return stats jsp link
             * @return {string} url path
             */

        }, {
            key: 'getStatsLink',
            value: function getStatsLink(statsapiGame, sId) {
                var gid = _getGID(statsapiGame, this);
                var siteId = sId || this.siteId;
                return _getStatsLink(this.milbHostName, gid, 'milb');
            }

            /**
             * Returns a player-page link based on player ID and team ID.
             * @param {object} leader The player's leader object.
             * @return {string} The player-page link for example: http://www.milb.com/player/index.jsp?sid=t234&player_id=642715
             */

        }, {
            key: 'getPlayerPageLinkById',
            value: function getPlayerPageLinkById(leader) {
                var complexLeague = [121, 124, 130]; // DIGIT-1409 different player link on Complex leagues.
                var leagueId = leader.league.id;
                var playerPageLink = '';
                if (leader) {
                    var sid = leagueId && complexLeague.indexOf(leagueId) !== -1 ? 'milb' : 't' + leader.team.id;
                    playerPageLink = this.milbHostName + '/player/index.jsp?sid=' + sid + '&player_id=' + leader.person.id;
                }
                return playerPageLink;
            }

            /**
             * Generates a tickets link based on game; whether user is desktop or mobile; what the current team is (we don't
             * yet handle league sites here, just club sites); and what types of links are available from statsapi (e.g., if
             * there's no mobile-specific link, we return the desktop link, etc.).
             * @param statsapiGame A Statsapi game node returned by, e.g., the Schedule API
             * @return {string}
             */

        }, {
            key: 'getTicketsLink',
            value: function getTicketsLink(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'any');
            }

            /**
             * Returns a ticket link IF AND ONLY IF there is one available which will take the user to a site where they can
             * purchase tickets from the context team (the team whose site they're visiting).  This method is meant to be used
             * in conjunction with getTicketsLinkNotForContextTeam(), which returns the "opposite" of what this method returns:
             * only non-context-team ticket links.
             *
             * This method (and its cousin getTicketsLinkNotForContextTeam()) are meant to be used instead of getTicketsLink()
             * when the consumer must know whether they're dealing with a context-team link or an opponent-team link (since in
             * some cases, we alert the user to the fact that they'll be purchasing tickets from the opponent if they proceed.
             * Expected use" consumer calls this method first; if it returns null, they call getTicketsLinkNotForContextTeam()
             * and offer the return value (if not null ofc) to the user, but telling them this is the opponent's link.
             * @param statsapiGame
             * @return {string} A url, or null if a ticket link meeting the criteria described above is not available
             */

        }, {
            key: 'getTicketsLinkForContextTeam',
            value: function getTicketsLinkForContextTeam(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'contextOnly');
            }

            /**
             * @see #getNGETicketsLinkForContextTeam - where that method returns links to buy tickets from the context team, this
             *   method returns links to buy tickets from the opponent team.
             * @param statsapiGame
             */

        }, {
            key: 'getNGETicketsLinkForContextTeam',
            value: function getNGETicketsLinkForContextTeam(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'opponentOnly', true);
            }

            /**
             * @see #getTicketsLinkForContextTeam - where that method returns links to buy tickets from the context team, this
             *   method returns links to buy tickets from the opponent team.
             * @param statsapiGame
             */

        }, {
            key: 'getTicketsLinkNotForContextTeam',
            value: function getTicketsLinkNotForContextTeam(statsapiGame) {
                return _getTicketsLink(statsapiGame, arguments.length > 1 ? arguments[1] : false, this, 'opponentOnly');
            }

            /**
             * @method getTeamStatsLink
             * @description Return team stats url
             * @return {string} url path
             */

        }, {
            key: 'getTeamStatsLink',
            value: function getTeamStatsLink(teamId) {
                return teamId ? this.milbHostName + '/milb/stats/stats.jsp?t=t_ibp&cid=' + teamId + '&stn=true&sid=t' + teamId : null;
            }

            /**
            * @method getTeamHomepageLinkFromTeamId
            * @description Return team homepage url
            * @return {string} url path
            */

        }, {
            key: 'getTeamHomepageLinkFromTeamId',
            value: function getTeamHomepageLinkFromTeamId(teamId) {
                var slug = this._teamSlugs && this._teamSlugs[teamId];
                return slug ? this.getLink('/' + slug, false) : null;
            }

            /**
             * @method getScheduleLink
             * @description Return schedule url maintaining team/league context if applicable
             * @return {string} url path
             */

        }, {
            key: 'getScheduleLink',
            value: function getScheduleLink() {
                return this.getLink('/schedule', true);
            }
        }]);

        return MilbLinker;
    }(BaseLinker);

    /**
     * @method _getStatsLink
     * @private
     * @description Return a stats link
     * @return {string} url path
     */

    function _getStatsLink(host, gid, siteId) {
        return host + '/milb/stats/stats.jsp?gid=' + gid + '&t=g_rcp&sid=' + siteId;
    }
    /**
     * Return the specified ticket link if available, otherwise null
     * @param statsapiGame A SD API game node
     * @param forceDesktop If true, only desktop links will be returned; if false, mobile ones will be returned as well
     * @param linker the MlbLinker instance calling this function
     * @param sellerType Which type of seller's link is okay to return?  Three possible values:
     *          - 'contextOnly': only return link to seller associated with the context team
     *          - 'opponentOnly': only return link to seller asociated with the opponent
     *          - 'any' expected to be called only when there isn't a context (i.e., the league site), returns the home
     *            team's seller's link if it exists; otherwise returns the away team's seller's link
     *
     * @return {string} A URL or null
     * @private
     */
    function _getTicketsLink(statsapiGame, forceDesktop, linker, sellerType, nonGameEvent) {
        if (!nonGameEvent) {
            BamArgValidator$1.validateStatsapiGame(statsapiGame);
            BamArgValidator$1.validateArgs(arguments, ['statsapiGame', 'forceDesktop', 'linker', 'sellerType'], ['object', 'boolean', 'object', 'string'], [true, true, true, true]);
        } else {
            BamArgValidator$1.validateStatsapiNonGameEvent(statsapiGame);
        }
        BamArgValidator$1.validateAllowed(sellerType, ['any', 'contextOnly', 'opponentOnly']);

        if (sellerType !== 'any' && !linker._teamId || statsapiGame.status && statsapiGame.status.abstractGameCode === 'F') {
            return null;
        }

        if (statsapiGame.tickets) {
            var awayId = !nonGameEvent ? statsapiGame.teams.away.team.id : statsapiGame.teams[0] && statsapiGame.teams[0].id;
            var url = null;
            var homeOrAway = +linker._teamId === awayId ? 'away' : 'home';

            if (sellerType === 'any') {
                url = _getTicketsLinkOfType(statsapiGame.tickets, 'home', linker) || _getTicketsLinkOfType(statsapiGame.tickets, 'away', linker);
            } else {
                homeOrAway = sellerType === 'contextOnly' ? awayId === +linker._teamId ? 'away' : 'home' : awayId !== +linker._teamId ? 'away' : 'home';

                if (nonGameEvent) {
                    homeOrAway = 'home';
                }

                url = _getTicketsLinkOfType(statsapiGame.tickets, homeOrAway, linker);
            }

            if (url !== null) {
                var homeTeam = statsapiGame.teams.home && statsapiGame.teams.home.team;
                // handle games where home team is not playing in their home venue
                if (homeTeam && +linker._teamId === homeTeam.id && statsapiGame.venue.id !== homeTeam.venue.id) {
                    homeOrAway = 'away';
                }
                // prepend redirect url to interstitial
                url = '/tickets/interstitial/' + homeOrAway + '?jumpTo=' + encodeURIComponent(url);

                return url;
            }
        }

        // If deviceType is mobile and there is no mobile link, try to return the desktop link instead
        if (!forceDesktop && linker._deviceType !== 'desktop') {
            return _getTicketsLink(statsapiGame, true, linker, sellerType);
        }

        return null;
    }

    /**
     * Returns a ticket link based on the specified type (home or away) and other criteria
     * @param ticketsArr Array of
     * @param homeOrAway
     * @param linker an MlbLinker instance
     * @private
     */
    function _getTicketsLinkOfType(ticketsArr, homeOrAway, linker) {
        var ticketType = linker._deviceType === 'mobile' ? 'mobile' : 'wired';
        var ln = ticketsArr.length;
        var ticketEl = void 0;
        var i = void 0;

        for (i = 0; i < ln; i++) {
            ticketEl = ticketsArr[i];
            if (ticketEl.ticketType && ticketEl.ticketType === ticketType) {
                if (ticketEl.ticketLinks && ticketEl.ticketLinks[homeOrAway]) {
                    return ticketEl.ticketLinks[homeOrAway];
                }
            }
        }

        return null;
    }

    /**
     * Return the specified TuneIn audio link if available, otherwise null
     * @param statsapiGame A SD API game node
     * @param linker the MlbLinker instance calling this function
     * @param homeAwayContext Which team's audio is okay to return?  Three possible values:
     *          - 'contextOnly': only return audio associated with the context team
     *          - 'home': only return audio asociated with the home team
     *          - 'away': only return audio asociated with the away team
     *          - 'any' expected to be called only when there isn't a context (i.e., the league site), returns the home
     *            team's audio link if it exists; otherwise returns the away team's audio link
     *
     * @return {string} A URL or null
     * @private
     */
    function _getTuneInLink(statsapiGame, linker, homeAwayContext) {
        BamArgValidator$1.validateStatsapiGame(statsapiGame);
        BamArgValidator$1.validateArgs(arguments, ['statsapiGame', 'linker', 'homeAwayContext'], ['object', 'object', 'string'], [true, true, true, true]);
        BamArgValidator$1.validateAllowed(homeAwayContext, ['contextOnly', 'home', 'away', 'any']);

        var url = null;
        if (statsapiGame.broadcasts) {
            var showHome = homeAwayContext === 'home';
            var showAway = homeAwayContext === 'away';

            if (homeAwayContext === 'contextOnly') {
                var awayId = statsapiGame.teams.away.team.id;
                showHome = linker._teamId !== awayId;
                showAway = linker._teamId === awayId;
            }
            if (homeAwayContext === 'any') {
                showHome = true;
                showAway = true;
            }

            var b = void 0;
            for (b = 0; b < statsapiGame.broadcasts.length; ++b) {
                if (statsapiGame.broadcasts[b].id === 4955) {
                    // RETURNS LINK TO PAGEBUILDER AWS UNTIL API RETURNS SPECIFIC LINKS
                    // BDFED-2392
                    if (showHome && statsapiGame.broadcasts[b].homeAway === 'home') {
                        return linker.getLink('live-stream-games/audio', false);
                    }
                    if (showAway && statsapiGame.broadcasts[b].homeAway === 'away') {
                        return linker.getLink('live-stream-games/audio', false);
                    }
                }
            }
        }
        return url;
    }

    function _getGID(statsapiGame, linker) {

        var awayTeamCode = statsapiGame.teams.away.team.teamCode;
        var homeTeamCode = statsapiGame.teams.home.team.teamCode;
        var awaySportCode = linker.sportCodeMap[statsapiGame.teams.away.team.sport.id];
        var homeSportCode = linker.sportCodeMap[statsapiGame.teams.home.team.sport.id];
        var gameNumber = statsapiGame.gameNumber;
        var gameDate = statsapiGame.gameDate.substr(0, 10);
        gameDate = gameDate.replace(/-/g, '_');

        return gameDate + '_' + awayTeamCode + awaySportCode + '_' + homeTeamCode + homeSportCode + '_' + gameNumber;
    }

    module.exports = MilbLinker;

    /***/
}]
/******/);
});